import LayoutAuth from '@/views/auth/the-layout.vue'

export default {
  path: '/auth',
  component: LayoutAuth,
  children: [
    {
      path: '/masuk',
      name: 'login',
      component: () => import('@/views/auth/page-login.vue'),
      meta: { title: 'Masuk' },
    },
  ],
}
